export default __webpack_public_path__ + "static/media/05.a3daced4.png";